// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array } from 'prop-types'
import ModulationRow from './ModulationRow'

const ModulationsSummary = ({ modulations }) => {
  // sets eng reference for UI display.
  modulations.find(m => {
    if (m.enabled) {
      m.engineeringReferenceFlag = true
      return true
    }
  })

  return (
    <dl className={'modulations-tooltip scoot-left'}>
      <dt>
        <p className={'tooltip-trigger-decoration show-decoration acm-tooltip-decoration'}>
          {'ACM'}
        </p>
        <p>{'Adaptive Modulation'}</p>
      </dt>
      <dd>
        <table>
          <thead>
            <tr>
              <th>
                {'Modulation /'}
                <br/>
                {'Throughput (Mbps)'}
              </th>
              <th>
                {'Power'}
                <br />
                {'(dBm)'}
              </th>
            </tr>
          </thead>
          <tbody>
            {modulations.map((d, i) => (
              <ModulationRow
                key={d.radioModulationId}
                {...d} />
            ))}
          </tbody>
        </table>
      </dd>
    </dl>
  )
}

ModulationsSummary.propTypes = {
  modulations: array.isRequired,
}

export default ModulationsSummary
